<template>
  <div>
    <el-row :gutter="10" class="sales-time"
      v-for="(b, idx) in value"
      :key="idx"
      >
      <el-col :xs="24" :md="12">
        <text-field
          v-model="b.branch_name"
          base="user"
          name="branch_block.branch_name"
          :disabled="true"
          :prop="getBlockPropPath(idx, 'branch_name')"
          :hasLabel="idx <= 0"
          :hasDesc="true"
          :hasLeftTooltip="true"
          :leftTooltipContent="getLabelText('user', 'branch_block.bid') + ':' + b.bid"
          >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="b.remark"
          base="user"
          name="branch_block.remark"
          :disabled="true"
          :prop="getBlockPropPath(idx, 'remark')"
          :hasLabel="idx <= 0"
          >
        </text-field>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { getLabelText } from '@/utils/i18n'

export default {
  name: 'member-block',
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    getLabelText,
    getBlockPropPath (idx, name) {
      return `block.${idx}.${name}`
    }
  }
}
</script>
